export const DEFAULT_SKYBOX = 'day'
